export const LabelText = {
  TITLE: 'Employees',
  SUBTITLE: 'Manage and update employee information',
  ADD_DROPDOWN_BUTTON: 'Add employees',
  ADD_BUTTON: 'Manually add',
  UPLOAD_BUTTON: 'Bulk upload',
  MORE_BUTTON: 'More',
  DELETE_BUTTON: 'Delete employees',
  EXPORT_BUTTON: 'Export employees',
  EMPLOYEE_ROLE: {
    USER: 'User',
    MANAGER: 'Manager'
  },
  ADD_EMPLOYEE: {
    TITLE: 'Add an employee',
    SUBMIT_BUTTON: 'Submit',
    SUBMIT_ANOTHER_BUTTON: 'Save and add another'
  },
  EDIT_EMPLOYEE: {
    TITLE: 'Edit employees',
    EDIT_BUTTON: 'Edit',
    BASIC_INFORMATION_TITLE: 'Basic Information',
    SERVICES_TITLE: 'Services',
    USER_ROLE_TITLE: 'User Role*',
    ACCOUNT_STATUS_TITLE: 'Account Status',
    DELETE_PROFILE_TITLE: 'Delete Profile',
    DELETE_BUTTON: 'Delete'
  },
  UPLOAD_EMPLOYEE: {
    TITLE: 'Upload CSV'
  },
  EMPLOYEE_LISTING: {
    CTA_TITLE: 'Add employees to manage their expenses and benefits',
    CTA_SUBTITLE:
      'Upload a CSV file to add employees in bulk, or add them manually instead',
    CTA_BUTTON: 'Bulk upload employees'
  },
  BULK_DELETE_EMPLOYEE: {
    TITLE: `Delete employees`,
    WARNING:
      'The employee emails you upload will be deleted from the account immediately. Please note that this action cannot be undone',
    SUCCESS_MESSAGE_MULTIPLE: '%row% employees are ready to be deleted',
    SUCCESS_MESSAGE_SINGLE: '%row% employee is ready to be deleted',
    ERROR_MESSAGE:
      'Missing information in required fields. Please add the information required and upload the file again.'
  },
  STATS: {
    PENDING_EMPLOYEES: 'Pending employees',
    PENDING_EMPLOYEES_BUTTON: 'Resend invites'
  },
  CONFIRM_MODAL: {
    CONFIRM_BUTTON: 'Resend',
    CANCEL_BUTTON: 'Cancel',
    TITLE: 'Resend invites?',
    SUBTITLE: 'They can only be sent once every 24 hours'
  }
};
